import { ProductCardThumbnailProps } from '../types';

export const ProductCardThumbnail = ({
  imgProps
}: ProductCardThumbnailProps) => {
  return <img alt={imgProps?.alt} loading="lazy" {...imgProps} />;
};
